import React, { createContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import registerDefaults from './themeDefaults';

const styles = {
  root: {
    display: 'flex'
  }
};

registerDefaults();

export const ButtonToggleContext = createContext({});

export const BareButtonToggleGroup = ({
  selectedButtonId, onButtonSelected, children, className, classes
}) => {
  const buttonSelectedCallback = useCallback(newSelectedButtonId => {
    if (newSelectedButtonId !== selectedButtonId) {
      onButtonSelected(newSelectedButtonId);
    }
  }, [selectedButtonId, onButtonSelected]);

  return (
    <div className={`${classes.root} ${className}`}>
      <ButtonToggleContext.Provider
        value={{ onButtonSelected: buttonSelectedCallback, selectedButtonId }}
      >
        {children}
      </ButtonToggleContext.Provider>
    </div>
  );
};

BareButtonToggleGroup.propTypes = {
  /** The id of the currently selected button in this group */
  selectedButtonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Function to call when a button is selected
   *
   * @param {string|number} selectedButtonId - Id of the button that has been selected
   */
  onButtonSelected: PropTypes.func.isRequired,

  /** Child components to render inside button toggle group */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.element]),

  /** CSS class to add if desired */
  className: PropTypes.string,

  /** Classes for JSS styling */
  classes: PropTypes.shape({
    root: PropTypes.string
  }).isRequired
};

BareButtonToggleGroup.defaultProps = {
  selectedButtonId: undefined,
  children: undefined,
  className: ''
};

const ButtonToggleGroup = withStyles(styles)(BareButtonToggleGroup);
ButtonToggleGroup.displayName = 'ButtonToggleGroup';

export default ButtonToggleGroup;
